import React, { useEffect, useRef } from 'react';

/** Call this from anywhere to open the booking modal */
export const openBookingModal = () => {
  window.dispatchEvent(new CustomEvent('open-booking-modal'));
};

const BookingModal = ({ isOpen, onClose }) => {
  const iframeRef = useRef(null);

  useEffect(() => {
    if (!isOpen) return;
    document.body.style.overflow = 'hidden';

    const container = iframeRef.current;
    if (!container) return;

    while (container.firstChild) container.removeChild(container.firstChild);

    const iframe = document.createElement('iframe');
    iframe.src = 'https://app.iclosed.io/e/skyeai/ai-growth-planning-call-expedited-1';
    iframe.style.cssText = 'width:100%;border:none;display:block;overflow:hidden;';
    iframe.scrolling = 'no';
    iframe.title = 'Book Growth Planning Call';
    iframe.setAttribute('allow', 'clipboard-write');
    const isMobile = window.innerWidth < 768;
    iframe.style.height = isMobile ? '850px' : '520px';

    const handleMessage = (e) => {
      if (e.data && typeof e.data === 'string') {
        try {
          const msg = JSON.parse(e.data);
          if (msg.height) iframe.style.height = msg.height + 'px';
        } catch {}
      }
      if (e.data && typeof e.data === 'object' && e.data.height) {
        iframe.style.height = e.data.height + 'px';
      }
    };
    window.addEventListener('message', handleMessage);
    container.appendChild(iframe);

    return () => {
      window.removeEventListener('message', handleMessage);
      document.body.style.overflow = '';
      while (container.firstChild) container.removeChild(container.firstChild);
    };
  }, [isOpen]);

  useEffect(() => {
    if (!isOpen) return;
    const handleEsc = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="bm-overlay" onClick={onClose} data-testid="booking-modal-overlay">
      <div className="bm-modal" onClick={(e) => e.stopPropagation()} data-testid="booking-modal">
        <button className="bm-close" onClick={onClose} data-testid="booking-modal-close" aria-label="Close">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>
        </button>

        <div className="bm-header">
          <div className="bm-chip">
            <span className="bm-chip-dot" />
            <span>Limited spots this month</span>
          </div>
          <h2 className="bm-title">Book Your Free Growth Call</h2>
          <p className="bm-sub">Quick 30-min call. We'll show you how to fill your calendar with jobs.</p>
        </div>

        <div ref={iframeRef} className="bm-iframe" data-testid="booking-modal-iframe" />

        <div className="bm-trust">
          <span>4.7 <span className="bm-stars">★★★★★</span></span>
          <span className="bm-sep">|</span>
          <strong>Trusted by 300+ Businesses</strong>
        </div>
      </div>
    </div>
  );
};

export default BookingModal;
